import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2f19b081")

_pushScopeId("data-v-2f19b081")
const _hoisted_1 = { class: "relative flex flex-grow" }
const _hoisted_2 = { class: "\n        bg-red-500\n        text-white text-xs text-right\n        absolute\n        px-2\n        font-light\n        absolute\n        top-0\n        right-0\n        pointer-events-none\n        rounded-bl-md\n      " }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.type === 'password')
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "\n        absolute\n        right-2\n        top-0\n        bottom-0\n        flex\n        items-center\n        cursor-pointer\n        text-gray-500\n      ",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
        }, [
          (_ctx.showPassword)
            ? (_openBlock(), _createBlock(_component_fa_icon, {
                key: 0,
                icon: ['far', 'eye-slash'],
                size: "lg"
              }))
            : (_openBlock(), _createBlock(_component_fa_icon, {
                key: 1,
                icon: ['far', 'eye'],
                size: "lg"
              }))
        ]))
      : _createCommentVNode("", true),
    _createVNode("input", {
      ref: "inputRef",
      type: _ctx.inputType,
      readonly: _ctx.readonly,
      class: `rounded-sm ${
        _ctx.disabled ? 'text-gray-600 bg-gray-200' : 'text-black'
      } px-2 py-1.5 font-regular ring-2 ${_ctx.ring} transition-all duration-500 min-w-full focus:ring-green-800 block ${ _ctx.noMargin ? '':'my-3'}`,
      placeholder: _ctx.placeholder,
      value: _ctx.value,
      onInput: _cache[2] || (_cache[2] = (event) => _ctx.emitValue(event.target.value)),
      onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
      onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onFocusFn && _ctx.onFocusFn(...args))),
      step: _ctx.decimals,
      disabled: _ctx.disabled,
      maxlength: _ctx.maxLengthCalculated
    }, null, 42, ["type", "readonly", "placeholder", "value", "step", "disabled", "maxlength"]),
    (_ctx.value !== null)
      ? (_openBlock(), _createBlock("p", {
          key: 1,
          class: `absolute top-1 left-1 ${_ctx.labelColor} text-white text-xs px-2 rounded-md shadow-xs`
        }, _toDisplayString(_ctx.placeholder), 3))
      : _createCommentVNode("", true),
    _createVNode("p", _hoisted_2, _toDisplayString(_ctx.errorMessage), 1)
  ]))
})